import { defineComponent as _defineComponent } from 'vue'
import Error from './components/Error.vue';
import QsList from './components/QsList.vue';
import { getRecommendQsListApi } from './apis';
import { onMounted, ref } from 'vue';
import { BrokerItem } from './types';
import { getUserid } from '@king-fisher/khxtzsq-business';
import { sendShowStat, sendClickStat } from '@/utils/stat';
import { getPlatform } from '@/utils/tools';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showError = ref(false);
const param = window.getParaByName('data');
const qsList = ref<BrokerItem[]>([]);
const tjid = ref('');
const cssStyle = window.getCssStyle();
const getRecommendQsList = async () => {
  try {
    const res = await getRecommendQsListApi({
      param: param,
      ths_uid: getUserid(),
      platform: getPlatform(),
    });
    const { code, data } = res;
    if (code === 0) {
      qsList.value = data?.brokerList || [];
      tjid.value = data?.tjid || '';
      sendShowStat('gpkh_cot_scenelist', { activityId: tjid.value });
      const length = qsList.value.length;
      if (length === 0) {
        showError.value = true;
      } else if (length > 1) {
        showError.value = false;
      } else {
        window.registerWebListener('onShow', () => {
          const type = window.getPlatform() === 'iphone' ? 'component' : 'webpage';
          window.callNativeHandler('goback', { type });
        });
        const broker = qsList.value[0] as BrokerItem;
        sendClickStat('gpkh_cot_scenelist_pgclick_specific', { activityId: tjid.value, qs: broker?.brokerId });
        showError.value = false;
        window.jumpToKaihu({ webid: 'PagePhoneVerification', 'qsid': broker?.brokerId, 'tjid': tjid.value });
      }
    } else {
      sendShowStat('gpkh_cot_scenelist', { activityId: tjid.value });
      showError.value = true;
    }
  } catch (error) {
    sendShowStat('gpkh_cot_scenelist', { activityId: tjid.value });
    showError.value = true;
  }
};
const init = async () => {
  getRecommendQsList();
};
onMounted(() => {
  init();
});

return { __sfc: true,showError, param, qsList, tjid, cssStyle, getRecommendQsList, init, Error, QsList }
}

})